module.exports = __webpack_public_path__ + "static/media/03.ee3495f5.jpg";